import React, {useState} from 'react';



const Index = (props) => {
  return (
    <>
        <div className="ome__topbar">
            🎉 Summer Sale is LIVE — <span>Up to 50% Off</span> on top brands. Shop before it ends!
        </div>
    </>
  );
};

export default Index;
